import { getDeviceId } from 'usage-tracker-core/common/defaultTrackers';
import anonymousStorage from 'usage-tracker-core/containers/anonymousStorage';

// For our current tracking, only the anonymous storage is applicable due to the way we use the usage tracker
export const getUserExperimentIdentifier = () => getDeviceId(anonymousStorage);